var PasswordStrength;
(function (PasswordStrength) {
    PasswordStrength[PasswordStrength["Weak"] = 0] = "Weak";
    PasswordStrength[PasswordStrength["Good"] = 1] = "Good";
    PasswordStrength[PasswordStrength["Strong"] = 2] = "Strong";
})(PasswordStrength || (PasswordStrength = {}));
var PasswordValidationErrors;
(function (PasswordValidationErrors) {
    PasswordValidationErrors["MinLength"] = "MinLength";
    PasswordValidationErrors["MaxLength"] = "MaxLength";
    PasswordValidationErrors["MissingLowercase"] = "MissingLowercase";
    PasswordValidationErrors["MissingUppercase"] = "MissingUppercase";
    PasswordValidationErrors["MissingDigit"] = "MissingDigit";
})(PasswordValidationErrors || (PasswordValidationErrors = {}));

export { PasswordStrength, PasswordValidationErrors };
